import { render, staticRenderFns } from "./Reviewlist.vue?vue&type=template&id=1ef9fb23&scoped=true&"
import script from "./Reviewlist.vue?vue&type=script&lang=js&"
export * from "./Reviewlist.vue?vue&type=script&lang=js&"
import style0 from "./Reviewlist.vue?vue&type=style&index=0&id=1ef9fb23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9fb23",
  null
  
)

export default component.exports